/** @format */

import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { setProductReviewState, setBVPixelState } from '../actions';

@Injectable()
export class BVPixelEffects {
	addBVPixelObject$ = createEffect(() =>
		this.actions$.pipe(
			ofType(setProductReviewState),
			map(({ productIdentifier, reviewSummary: { brand, category } }) => {
				const bvPixel = {
					brand,
					category,
					productId: productIdentifier,
				};
				return setBVPixelState(bvPixel);
			})
		)
	);

	constructor(private actions$: Actions) {}
}
